import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ToggleButtons, CatcherDepth } from 'yankees-react-utils';

const VIEW = { ALL: 'all', LHH: 'lhh', RHH: 'rhh' };

const ReceivingCatchingDepth = ({ catcherDepthData, catcherDepthLevelAvgData }) => {
    const { t: translate } = useTranslation();
    const [view, setView] = useState(VIEW.ALL);
    const options = [
        { name: translate('common.all'), value: VIEW.ALL, variant: 'default' },
        { name: translate('baseball.lhh'), value: VIEW.LHH, variant: 'default' },
        { name: translate('baseball.rhh'), value: VIEW.RHH, variant: 'default' },
    ];

    if (catcherDepthData.length === 0) {
        return (
            <div>
                <h4>{translate('sections.reports.catcher.receiving.catcher-depth')}</h4>
                {translate('sections.reports.catcher.receiving.no-depth-data')}
            </div>
        );
    }

    let name = '';
    let data = [];
    let leagueAverage = catcherDepthLevelAvgData.find((d) => d.islhb === null)
        ? catcherDepthLevelAvgData.find((d) => d.islhb === null).cy * -1
        : null;
    if (view === VIEW.ALL) {
        name = translate('sections.reports.catcher.receiving.catcher-depth');
        data = catcherDepthData.map((d) => d.y * -1);
        leagueAverage = catcherDepthLevelAvgData?.find((d) => d.islhb === null)
            ? catcherDepthLevelAvgData?.find((d) => d.islhb === null).cy * -1
            : null;
    } else if (view === VIEW.LHH) {
        name = `${translate('sections.reports.catcher.receiving.catcher-depth')} ${translate('baseball.abbr-versus')} ${translate('baseball.lhh')}`;
        data = catcherDepthData.filter((d) => d.islhb === true).map((d) => d.y * -1);
        leagueAverage = catcherDepthLevelAvgData?.find((d) => d.islhb === true)
            ? catcherDepthLevelAvgData?.find((d) => d.islhb === true).cy * -1
            : null;
    } else if (view === VIEW.RHH) {
        name = `${translate('sections.reports.catcher.receiving.catcher-depth')} ${translate('baseball.abbr-versus')} ${translate('baseball.rhh')}`;
        data = catcherDepthData.filter((d) => d.islhb === false).map((d) => d.y * -1);
        leagueAverage = catcherDepthLevelAvgData?.find((d) => d.islhb === false)
            ? catcherDepthLevelAvgData?.find((d) => d.islhb === false).cy * -1
            : null;
    }
    const seriesData = { name, data, leagueAverage };

    return (
        <>
            <ToggleButtons name="receivingdepth" size="sm" options={options} onChange={(value) => setView(value)} defaultValue={VIEW.ALL} />
            <CatcherDepth
                seriesData={seriesData}
                title={name}
                titleHistogramX={translate('sections.reports.catcher.receiving.depth-in')}
                titleHistogramY={translate('baseball.count')}
            />
        </>
    );
};

ReceivingCatchingDepth.propTypes = {
    catcherDepthData: PropTypes.arrayOf(PropTypes.shape({
        islhb: PropTypes.bool,
        y: PropTypes.number,
    })).isRequired,
    catcherDepthLevelAvgData: PropTypes.arrayOf(PropTypes.shape({
        islhb: PropTypes.bool,
        cy: PropTypes.number,
    })).isRequired,
};

export default ReceivingCatchingDepth;
